/**
 * The end customer's details for a POS-insured order, as sent to the insurer.
 *
 * Deliberately the same eight fields as CustomerDeliveryAddress, but a SEPARATE record:
 * that entity carries delivery and invoicing semantics - populating it marks the order
 * as a direct-to-consumer delivery and re-routes the invoice e-mail. POS must change
 * neither, so it keeps its own storage (US-606 D3, spec.md ground rule 2).
 *
 * An order can legitimately carry both: a Bruuts table with a customer delivery address
 * and an insured sofa with a POS registration produce two independent records.
 */
export class PosRegistration {
  // US-685: allowed POS country values (ISO codes; was free text "Nederlands"). Must stay in step
  // with PosRegistration::COUNTRIES in the API. Use PosCountryCode for the derived union type.
  public static readonly COUNTRIES = {NL: 'NL', BE: 'BE', DE: 'DE'} as const;

  public static isCountry(value: string): value is PosCountryCode {
    return (Object.values(PosRegistration.COUNTRIES) as string[]).includes(value);
  }

  public id?: number;
  public fullName?: string;
  public phoneNumber?: string;
  public email?: string;
  public country?: string;
  public city?: string;
  public street?: string;
  public houseNumber?: string;
  public zipCode?: string;
  /** Null until the row has been included in a Layout 7 (POS) export run. */
  public exportedAt?: string;
}

export type PosCountryCode = typeof PosRegistration.COUNTRIES[keyof typeof PosRegistration.COUNTRIES];
